export default theme => ({
  topbar: {
    position: 'fixed',
    width: '100%',
    top: 0,
    left: 0,
    right: 'auto',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  topbarShift: {
    marginLeft: '271px',
    width: 'calc(-271px + 100vw)'
  },
  drawerPaper: {
    zIndex: 1200,
    width: '271px',
  },
  sidebar: {
    overflow: 'auto',
    overflowX: 'hidden',
    //width: '270px',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  customScrollBar: {
        '&::-webkit-scrollbar': {
            width: '0.4em',
        },
        '&::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-track-piece': {
            background: '#525252'
        },
        '&::-webkit-scrollbar-thumb:horizontal': {
            background: '#E5E5E5',
            },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#BBBBBB',
            outline: '1px solid slategrey'
        }
        
  },
  content: {
    marginTop: '90px',
    //backgroundColor: theme.palette.background.default,
    backgroundColor: '#e7e7e7',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  contentShift: {
    marginLeft: '270px'
  },
});




